module.exports = __webpack_public_path__ + "assets/96bdb09cbe6e7e3fed117070e596a1ee.png";